module.exports = __webpack_public_path__ + "static/media/ff_reporting.a9a7890d.png";